import { FcShape } from '@dtx-company/flowcode-generator-types/src'
import { FlowcodeShape } from '../ShapeSelector/ShapeSelector.types'
import { FlowcodeTemplateType } from '@app/common/src/types/createFlowcode.types'
import { ModalTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { useAddCenterImageState } from '../../AddCenterImage/AddCenterImage.hooks'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useCreateFlowcodeState } from '@app/code/src/hooks/useCreateFlowcodeState'
import { useCreateFlowcodeStateActions } from '../../CreateFlowcodeForm.hooks'
import { useModal } from '@dtx-company/inter-app/src/redux/slices/utils/modal'
import { useOnChangeSquareCodeCenterImage } from '@app/code/src/components/Homepage/CreateFlowcodeForm/AddCenterImage/UploadCenterImageInput/UploadCenterImageInput.hooks'
import { useShowProUpsellExperiment } from '@app/common/src/hooks/experiments'
import React, { useCallback } from 'react'

export const useManualDesignStep = (): {
  handleDesignOptionClick: (option: FlowcodeTemplateType) => void
  handleShapeOptionClick: (shape: FlowcodeShape) => void
} => {
  const hasUserDismissedProUpsellBanner = useCodeSelector(
    state => state.homePage.hasUserDismissedProUpsellBanner
  )
  const showProUpsellExperiment = useShowProUpsellExperiment()
  const { setTemplate, setBorderShape } = useCreateFlowcodeStateActions()
  const { setOpen: openProUpsellModal } = useModal(ModalTypes.PRO_UPSELL_HOMEPAGE_MODAL)
  const { setCenterImage } = useAddCenterImageState()
  const { centerImage: flowcodeLogo } = useCreateFlowcodeState()

  const handleDesignOptionClick = useCallback(
    (option: FlowcodeTemplateType): void => {
      if (!option.isCustomizable && !hasUserDismissedProUpsellBanner && showProUpsellExperiment) {
        openProUpsellModal()
      }

      setTemplate(option)
    },
    [hasUserDismissedProUpsellBanner, showProUpsellExperiment, openProUpsellModal, setTemplate]
  )
  const onChangeSquareCodeCenterImage = useOnChangeSquareCodeCenterImage(setCenterImage)
  const handleShapeOptionClick = useCallback(
    async (shape: FlowcodeShape) => {
      if (shape.shape === FcShape.SQUARE) {
        // logo for a square QR code must be uploaded to the server, for a circle, it can be blob
        if (flowcodeLogo?.objectUrl && flowcodeLogo.objectUrl.startsWith('blob:')) {
          const blob = await fetch(flowcodeLogo.objectUrl).then(r => r.blob())
          const file = new File([blob], flowcodeLogo.name)
          onChangeSquareCodeCenterImage({
            target: {
              files: [file]
            }
          } as unknown as React.ChangeEvent<HTMLInputElement>)
        }
      }
      setBorderShape(shape.shape)
    },
    [setBorderShape, onChangeSquareCodeCenterImage, flowcodeLogo.name, flowcodeLogo.objectUrl]
  )

  return {
    handleDesignOptionClick,
    handleShapeOptionClick
  }
}
